enum Permissions {
	CREATE_MY_CARTS = 'CreateMyCarts',
	UPDATE_BUSINESS_UNIT_DETAILS = 'UpdateBusinessUnitDetails',
	UPDATE_APPROVAL_FLOWS = 'UpdateApprovalFlows',
	VIEW_MY_QUOTES = 'ViewMyQuotes',
	VIEW_OTHERS_QUOTES = 'ViewOthersQuotes',
	DECLINE_MY_QUOTES = 'DeclineMyQuotes',
	DECLINE_OTHERS_QUOTES = 'DeclineOthersQuotes',
}

export default Permissions;
